module.exports = __webpack_public_path__ + "img/07_Lichtwirkung-Preis.ade06d55.svg";